import React from 'react';
import { IconBox, IconProps } from '@summer/jst-react-icon';

export const AddIcon = (props: Omit<IconProps, 'ref'>) => (
  <IconBox {...props}>
    <path d="M29 2h6v60h-6z" />
    <path d="M62 29v6H2v-6z" />
  </IconBox>
);
